// extracted by mini-css-extract-plugin
export default {"textContainer":"Cookies_textContainer__CmZtc","cookiesContainer":"Cookies_cookiesContainer__ziWq6","links":"Cookies_links__PUgIx"};